// Wrapper around fetch: JSON + timeout + abort support
export async function fetchJSON (url, { signal, timeoutMs = 15000, ...opts } = {}) {
  const ctrl = new AbortController()
  const timer = setTimeout(() => ctrl.abort(new DOMException('Timeout', 'AbortError')), timeoutMs)
  try {
    const res = await fetch(url, { ...opts, signal: mergeSignals(signal, ctrl.signal) })
    if (!res.ok) throw new Error(`HTTP ${res.status} for ${url}`)
    return await res.json()
  } finally {
    clearTimeout(timer)
  }
}

// Combine 2 AbortSignals; if either aborts, request aborts
function mergeSignals (a, b) {
  if (!a) return b
  if (!b) return a
  const ctrl = new AbortController()
  const onAbort = () => ctrl.abort()
  a.addEventListener('abort', onAbort)
  b.addEventListener('abort', onAbort)
  if (a.aborted || b.aborted) ctrl.abort()
  return ctrl.signal
}
